import React from 'react'


export default class extends React.Component {

  render() {
    return (
      <div className="full big black">
        <div className="wrap content-block">

          <h2>Artikelen</h2>
          {/* "Kennis & Inzicht" en "Ghostin Backstage/Leven" */}
          <div>4 artikelen</div>
          {/* "1 artikel" dynamisch maken, dat het ook met de filters werkt. voor filters werken met een json. */}
          {/* random volgorde? per page refresh en per filter click? */}

          <div className="col-3">
            <div className="card more-rounded card-black">
              <a href="/de-executives-gids-voor-linkedin-ghostwriting-hoe-jij-jouw-personal-brand-kunt-opschalen"><h3 style={{margin: "0", fontSize:"1.9em"}}>De Executive’s Gids voor LinkedIn Ghostwriting: Hoe jij jouw Personal Brand kunt opschalen</h3></a>
            </div>
          </div>

          <div className="col-3">
            <div className="card more-rounded card-black">
              <a href="/consistent-schrijven-hoe-kun-jij-iedere-week-berichten-plaatsen-op-linkedin"><h3 style={{margin: "0", fontSize:"1.9em"}}>Consistent schrijven: Hoe kun jij iedere week berichten plaatsen op LinkedIn?</h3></a>
            </div>
          </div>

          <div className="col-3">
            <div className="card more-rounded card-black">
              <a href="/een-uitgebreide-samenvatting-van-honderden-profiel-analyses"><h3 style={{margin: "0", fontSize:"1.9em"}}>Een uitgebreide samenvatting van honderden profiel analyses</h3></a>
            </div>
          </div>

          <div className="col-3">
            <div className="card more-rounded card-black">
              <a href="/duizenden-euros-coaching-maar-de-eerste-sessie-overgeslagen"><h3 style={{margin: "0", fontSize:"1.9em"}}>Duizenden euro's coaching, maar de eerste sessie overgeslagen..</h3></a>
            </div>
          </div>

        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Articles.js